export const footerInformation = [
  '경기도 고양시 일산동구 백마로 195, SK엠시티타워 일반동 13층',
  '사업자번호 813-87-01236',
  '통신판매 제2019-고양일산동-1344호',
  '대표자명 이상필, 문영화',
  '대표번호 1877-3793',
  '대표이메일 cs@viewup.co.kr',
];
